import { type PackageType } from '../shipping-items/domain/PackageType'
import { type ShippingItem } from '../shipping-items/domain/ShippingItem'
import { isNumber } from '../utils/number'
import { isString, isNotEmpty } from '../utils/string'

export type CommodityItem = {
  commodity?: string
  freightClass?: string
  height?: number
  length?: number
  nmfcCode?: string
  packageCount?: number
  packageType?: PackageType
  stackable?: boolean
  turnable?: boolean
  weight?: number
  width?: number
  commodities?: Array<ShippingItem>
}

export function hasCommodity(item: CommodityItem): boolean {
  return isString(item.commodity) && isNotEmpty(item.commodity)
}

export function hasSize(item: CommodityItem): boolean {
  return isNumber(item.height) || isNumber(item.length) || isNumber(item.width)
}

export function hasWeight(item: CommodityItem): boolean {
  return isNumber(item.weight)
}

export function isItemEmpty(item: CommodityItem): boolean {
  return !hasCommodity(item) && !hasSize(item) && !hasWeight(item)
}

export function getTotalWeight(items: CommodityItem[]) {
  return items.reduce((total, item) => total + Number(item.weight), 0)
}
